import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserStore } from '@store/user/user.store';

export const LoggedGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router: Router = inject(Router);

  if (!userStore.isUserLoggedIn()) {
    router.navigate(['/']);
  }

  return !!userStore.isUserLoggedIn();
};
